import { useCallback } from "react";

import { ClientGateway } from "@kex/api";
import { useIntl } from "react-intl";

import {
  type RequisitesCaptionAccount,
  getRequisitesCaptionMessages,
} from "./get-requisites-caption-messages";

export const useBankAccountCaption = (
  clientType: ClientGateway.ClientTypesEnum,
) => {
  const { formatMessage } = useIntl();

  return useCallback(
    (account: RequisitesCaptionAccount) => {
      const messages = getRequisitesCaptionMessages(clientType, account);
      return messages
        .map((line) => formatMessage(line.descriptor, line.values))
        .join("\n");
    },
    [clientType, formatMessage],
  );
};
